import { defineMessages } from 'react-intl';

export const spacesMessages = defineMessages({
    spaces: {
        id: 'spaces',
        defaultMessage: 'Spaces',
    },
    space: {
        id: 'space',
        defaultMessage: 'Space',
    },
    number: {
        id: 'number',
        defaultMessage: 'Number',
    },
    zone: {
        id: 'zone',
        defaultMessage: 'Zone',
    },
    type: {
        id: 'type',
        defaultMessage: 'Type',
    },
    isFree: {
        id: 'is-free',
        defaultMessage: 'Is free',
    },
    isReserved: {
        id: 'is-reserved',
        defaultMessage: 'Is reserved',
    },
    disallowedVisitorCategories: {
        id: 'disallowed-visitor-categories',
        defaultMessage: 'Disallowed visitor categories',
    },
    createSpaceSuccess: {
        id: 'create-space-success',
        defaultMessage: 'Space created',
    },
    createSpaceSuccessDescription: {
        id: 'create-space-success-description',
        defaultMessage: 'Space has been successfully created.',
    },
    addSpaceSubtitle: {
        id: 'add-space-subtitle',
        defaultMessage: 'Create a new space',
    },
    subscription: {
        id: 'subscription',
        defaultMessage: 'Subscription',
    },
    deleteSpaceSuccess: {
        id: 'delete-space-success',
        defaultMessage: 'Space deleted',
    },
    deleteSpaceSuccessDescription: {
        id: 'delete-space-success-description',
        defaultMessage: 'Space {entry} has been successfully deleted.',
    },
    deleteSpaceSubtitle: {
        id: 'delete-space-subtitle',
        defaultMessage: 'Permanently delete space {entry}',
    },
    confirmDeleteSpace: {
        id: 'confirm-delete-space',
        defaultMessage: 'Are you sure you want to delete space {entry}? This action cannot be undone.',
    },
    updateSpaceSuccess: {
        id: 'update-space-success',
        defaultMessage: 'Space updated',
    },
    updateSpaceSuccessDescription: {
        id: 'update-space-success-description',
        defaultMessage: 'Space {entry} has been successfully updated.',
    },
    multipleSpaces: {
        id: 'multiple-spaces',
        defaultMessage: 'Multiple spaces',
    },
    addMultipleSpacesSubtitle: {
        id: 'add-multiple-spaces-subtitle',
        defaultMessage: 'Create multiple spaces at once',
    },
    startNumber: {
        id: 'start-number',
        defaultMessage: 'Start number',
    },
    endNumber: {
        id: 'end-number',
        defaultMessage: 'End number',
    },
    createBulkSpaceSuccess: {
        id: 'create-bulk-space-success',
        defaultMessage: 'Multiple spaces created',
    },
    createBulkSpaceSuccessDescription: {
        id: 'create-bulk-space-success-description',
        defaultMessage: 'Multiple spaces have been successfully created.',
    },
    family: {
        id: 'family',
        defaultMessage: 'Family',
    },
    regular: {
        id: 'regular',
        defaultMessage: 'Regular',
    },
    disabledSpace: {
        id: 'disabled-space',
        defaultMessage: 'Disabled',
    },
    motorcycle: {
        id: 'motorcycle',
        defaultMessage: 'Motorcycle',
    },
    bus: {
        id: 'bus',
        defaultMessage: 'Bus',
    },
    big: {
        id: 'big',
        defaultMessage: 'Big',
    },
});
